import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Branch } from 'src/app/core/interfaces/branch.interface';
import { environment } from 'src/environments/environment';
import { Filter } from '../interfaces/filter.interface';
import { PREMISSIONS } from '../enums/permissions';
import { PermissionService } from './permission.service';
import {
    InventoryControlBasedOnType,
    InventoryControlSettingsPayload
} from '../interfaces/inventory-control-settings.interface';

@Injectable({
    providedIn: 'root'
})
export class BranchService {
    private baseUrl = environment.apiBaseUrl;
    //https://stg.api.getyusr.com/api/v1

    constructor(private http: HttpClient, private permissionService: PermissionService) {
        // Only call getDefaultBranch if user is logged in to avoid interceptor errors
        // This will be called when needed, not in constructor
    }

    getBranch = (id: number): Observable<any> => {
        if(!this.permissionService.hasPermission(PREMISSIONS.Branch.View)) return of(null);
        return this.http.get<any>(`${this.baseUrl}/Structure/Branch/${id}`);
    }

    listBranches = (pageNumber = 1, pageSize = 10, term = '', filters?: Filter[]): Observable<any> => {
        const data = {
            term,
            pageNumber,
            pageSize,
            advancedFilter: filters
        };
        return this.http.post(`${this.baseUrl}/Structure/Branch/list`, data);
    }
    listBranchesbyUser = (userid?:number): Observable<any> => {

      return this.http.get(`${this.baseUrl}/User/${userid}/branch-permissions/list`);
  }
//api/v{version}/User/{userId}/branch-permissions/list

    createBranch = (data: Branch): Observable<any> => {
        return this.http.post(`${this.baseUrl}/Structure/Branch`, data);
    }

    updateBranch = (data: Branch): Observable<any> => {
        return this.http.put(`${this.baseUrl}/Structure/Branch`, data);
    }

    getInventoryControlSettings = (
        basedOnType: InventoryControlBasedOnType,
        basedOnId: number
    ): Observable<any> => {
        return this.http.get(`${this.baseUrl}/Setting/inventory-control/Branch/${basedOnId}`);
    }

    updateInventoryControlSettings = (
        basedOnType: InventoryControlBasedOnType,
        basedOnId: number,
        data: InventoryControlSettingsPayload
    ): Observable<any> => {
        return this.http.put(`${this.baseUrl}/Setting/inventory-control/Branch/${basedOnId}`, data);
    }

    deleteBranch = (id: number): Observable<any> => {
        return this.http.delete(`${this.baseUrl}/Structure/Branch/${id}`);
    }

    getDefaultBranch = (isCachable = false): Observable<any> => {
        const options = isCachable ? { headers: { 'X-Use-Cache': 'true' } } : {};
        return this.http.get<any>(`${this.baseUrl}/Structure/Branch/default`, options);
    }

    setDefaultBranch = (id: number): Observable<any> => {
        return this.http.put<any>(`${this.baseUrl}/Structure/Branch/set-default/${id}`, {});
    }

    /**
     * Returns the branch's default currency id (currency only, not inventory).
     * Used by account statement pages to pre-select currency dropdown.
     * @param branch - Branch object from getDefaultBranch/getBranch API response (use .data if wrapped)
     */
    getDefaultCurrencyId(branch: { currencyId?: number; currency?: { id: number }; defaultCurrencyId?: number } | null | undefined): number | undefined {
        if (!branch) return undefined;
        return branch.currencyId ?? branch.currency?.id ?? branch.defaultCurrencyId;
    }
}
